import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { qryAvailablePlanListBsnl, changeSubsPlanBsnl } from '@/pages/ModifyPlan/services';
import { getRequestData } from '@/utils';


const defaultState = {
  step: 0, // 修改套餐的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  offerDtoList: [], // 可更换的主套餐列表
  total: 0,
  pageInfo: {},
};

export default {
  namespace: 'modifyPlan',
  state: defaultState,
  effects: {
    * qryAvailablePlanListBsnl({ payload }, { call, put, select }) {
      const selectSubsInfo = yield select(state => state.modifyPlan.selectSubsInfo);
      
      const result = yield call(qryAvailablePlanListBsnl, { ...payload, pageReqDto: payload.pageInfo, subsId: get(selectSubsInfo, 'subsId') });
      const { offerDtoList, pageReqDto } = getRequestData(result);
      if (get(pageReqDto, 'currentPage') === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: get(pageReqDto, 'total') || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: { offerDtoList: offerDtoList || [], pageInfo: pageReqDto || {} },
      });
      return { offerList: offerDtoList || [], pageDto: pageReqDto || [] };
    },
    * changeSubsPlanBsnl({ payload }, { call }) {
      const result = yield call(changeSubsPlanBsnl, payload);
      return getRequestData(result);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
